import Vue from 'vue'
import Vuex from "vuex";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

import UserModel from '../models/User';

import forces from './modules/forces';
import ranks from './modules/ranks';
import lpas from './modules/lpas';
import neighbourhoods from './modules/neighbourhoods';
import users from './modules/users';
import roles from './modules/roles';
import productcategories from './modules/productcategories';
import retailers from './modules/retailers';
import retailertypes from './modules/retailertypes';
import risks from './modules/risks';
import purposes from './modules/purposes';

export default new Vuex.Store({
	state: {
		currentUser: new UserModel({}),
        loggedIn: false,
        sessionLoaded: false,
	},

	mutations: {
		login(state, data){
            state.currentUser = new UserModel(data.logged_in_user);
            state.loggedIn = true;
            state.sessionLoaded = true;
        },
        logout(state){
            state.currentUser = null;
            state.loggedIn = false;
            state.sessionLoaded = true;
        }
	},

	modules: {
        forces,
        ranks,
        lpas,
        neighbourhoods,
        users,
        roles,
        productcategories,
        retailers,
        retailertypes,
        risks,
        purposes
	},
	strict: debug,
})

